"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FORM_FIELDS = void 0;
var FORM_FIELDS = exports.FORM_FIELDS = {
  DATES: 'dates',
  NAME: 'name',
  MANAGER_ID: 'manager',
  RECIPIENT: 'recipient',
  STATUS: 'status',
  PAGE: 'page'
};